module.exports = __webpack_public_path__ + "880cffe4febaa7476b6aee71db68b7e4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-ThinItalic.woff2
// module id = 982
// module chunks = 0